import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Navigate, useNavigate } from "react-router-dom";
import {
  getDocumentsId,
  getDocuments,
} from "../../redux/actions/actionDocument";
import { getItems } from "../../redux/actions/actionItem";
import { putDocuments } from "../../redux/actions/actionDocument";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import Swal from "sweetalert2";
import DetailPDF from "./detailPDF";
import { customStylesItems } from "../../Constantes/constantesEstilos";

export default function DocumentModify() {
  let dateAux = format(new Date(), "yyyy/MM/dd");

  const initialForm = {
    addressEvent: "",
    dateSend: "",
    dateReception: "",
    quantityItems: [],
  };

  const products = {
    item: "",
    name: "",
    descrip: "",
    quantity: "",
    price: 0,
    totalPrice: 0
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const documents = useSelector((state) => state.documents.allDocuments);
  const documentId = useSelector((state) => state.documents.documentsDetail);
  const items = useSelector((state) => state.items.allItems);
  const [startDate] = useState(new Date());
  // const [startDateSend] = useState(documentId.dateSend);
  // const [startDateReception] = useState(new Date());
  const [form, setForm] = useState(initialForm);
  const [product, setProduct] = useState(products);
  const [check, setCheck] = useState(false);
  const [verPDF, setVerPDF] = useState(false)

  useEffect(() => {
    dispatch(getDocuments());
    dispatch(getDocumentsId(id));
    dispatch(getItems());
  }, [dispatch, id]);

  console.log(documentId)

  const checkBox = () => {
    setCheck(!check);
    console.log(!check);
    if (!check) {
      setForm({
        ...form,
        addressEvent: documentId.addressEvent,
        dateSend: documentId.dateSend,
        dateReception: documentId.dateReception,
        quantityItems: documentId.quantityItems
      });      
    } else {
      setForm({
        addressEvent: "",
        dateSend: "",
        dateReception: "",
        //quantityItems: []
      });
    }
  };
  //console.log(check)
  const handleAddress = (e) => {
    const { value } = e.target;
    setForm({
      ...form,
      addressEvent: value,
    });
  };

  const handleDateSend = (date) => {
    setForm({
      ...form,
      dateSend: date
    });

    let noStock = [];
    
    let mapControl = form.quantityItems.map(e => {

      const inicio = date;
      const fin = new Date(form.dateReception);
      // const inicio = new Date("2023-06-01T00:00:00");
      // const fin = new Date("2023-06-30T00:00:00");
      const UN_DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24;
      const INTERVALO = UN_DIA_EN_MILISEGUNDOS * 7; // Cada semana
      const formateadorFecha = new Intl.DateTimeFormat({ dateStyle: "medium" });
      let stockPermitido = false;
      //console.log(inicio)
      for (
        let i = inicio;
        i <= fin;
        i = new Date(i.getTime() + UN_DIA_EN_MILISEGUNDOS)
      ) {
        let day = i;

        const documentsFilter = documents[0].filter(
          (e) =>
            new Date(e.dateReception) >= day &&
            new Date(e.dateSend) <= day && e.state === false &&
            e._id !== id
        ); //filtramos los remitos que esten activos el dia que se esta iterando
        console.log(documentsFilter);

        const auxItem = documentsFilter.map((x) =>
        x.quantityItems.find((y) => y.item === e.item)
      ); // filtramos los articulos que ingresamos en el formulario
      console.log(auxItem);

      const auxItemFilter = auxItem.filter(x => x !== undefined)
      console.log(auxItemFilter)

      if (auxItemFilter !== undefined) {
        console.log("ok");
        let sumaStock = 0; // recorremos las diferentes cantidades del articulo y las sumamos
        auxItemFilter.forEach(function (x) {
          sumaStock = parseInt(x.quantity) + sumaStock;
        });
        console.log(sumaStock);

        const stockItem = items.filter((x) => x._id === e.item); //filtramos el articulo desde nuestro array de articulos
        console.log(stockItem);

        const resultadoStock = stockItem[0].stockTotal - sumaStock; // restamos la suma de cantidades al stock total, dandonos por resultado el stock libre por dia
        console.log(resultadoStock);
        console.log(e.quantity)

        if (e.quantity > resultadoStock) {
          // si la cantidad ingresada es mayor al resultado de stock da verdadero, esto nos indica que no hay stock
          console.log(`El producto ${e.name} sobrepasa el stock`)
          // Swal.fire(
          //   `El producto ${e.name} sobrepasa el stock`
          //   );
            
            noStock.push(...noStock, {name:e.name, stock: resultadoStock})
          //return (stockPermitido = true);
        }
      } 
      // else {
      //   const stockItem = items.find((e) => e._id === product.item); //filtramos el articulo desde nuestro array de articulos
      //   console.log(stockItem);

      //   if (parseInt(product.quantity) > stockItem.stockTotal) {
      //     console.log(`El producto ${e.name} sobrepasa el stock`)
      //     Swal.fire(
      //       `Acaba de ingresar una cantidad que supera al stock actual. Stock permitido ${stockItem.stockTotal}`
      //     );
      //     return noStock.push(...noStock, {name:e.name, stock: stockItem.stockTotal})
      //   }

      //   console.log("bye");
      // }

       }


     }) //cierre del map
    
     if(noStock.length > 0) {
      let noStockSet = [...new Set(noStock)]
      let arrayStockSet = Array.from(noStockSet)
      console.log(arrayStockSet);
      Swal.fire({
      //   `${arrayStockSet.map(e =>       
      //   `Art: ${e.name} - Permitido ${e.stock}`        
      // )}`
            html: arrayStockSet.map(x => `Art: ${x.name} - Permitido ${x.stock}</br>`)
       }
      )
     }
     
     console.log(noStock);

  };

  const handleDateReception = (date) => {
    if(date >= new Date(form.dateSend)){
      setForm({
        ...form,
        dateReception: date
      });
    } else {
      Swal.fire(
        "La fecha de recepción no puede ser anterior a la fecha de envío"
      );
    }
    let noStock = [];
    
    let mapControl = form.quantityItems.map(e => {

      const inicio = new Date(form.dateSend);
      const fin = date;
      // const inicio = new Date("2023-06-01T00:00:00");
      // const fin = new Date("2023-06-30T00:00:00");
      const UN_DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24;
      const INTERVALO = UN_DIA_EN_MILISEGUNDOS * 7; // Cada semana
      const formateadorFecha = new Intl.DateTimeFormat({ dateStyle: "medium" });
      let stockPermitido = false;
      //console.log(inicio)
      for (
        let i = inicio;
        i <= fin;
        i = new Date(i.getTime() + UN_DIA_EN_MILISEGUNDOS)
      ) {
        let day = i;

        const documentsFilter = documents[0].filter(
          (e) =>
            new Date(e.dateReception) >= day &&
            new Date(e.dateSend) <= day && e.state === false &&
            e._id !== id
        ); //filtramos los remitos que esten activos el dia que se esta iterando
        console.log(documentsFilter);

        const auxItem = documentsFilter.map((x) =>
        x.quantityItems.find((y) => y.item === e.item)
      ); // filtramos los articulos que ingresamos en el formulario
      console.log(auxItem);

      const auxItemFilter = auxItem.filter(x => x !== undefined)
      console.log(auxItemFilter)

      if (auxItemFilter !== undefined) {
        console.log("ok");
        let sumaStock = 0; // recorremos las diferentes cantidades del articulo y las sumamos
        auxItemFilter.forEach(function (x) {
          sumaStock = parseInt(x.quantity) + sumaStock;
        });
        console.log(sumaStock);

        const stockItem = items.filter((x) => x._id === e.item); //filtramos el articulo desde nuestro array de articulos
        console.log(stockItem);

        const resultadoStock = stockItem[0].stockTotal - sumaStock; // restamos la suma de cantidades al stock total, dandonos por resultado el stock libre por dia
        console.log(resultadoStock);
        console.log(e.quantity)

        if (e.quantity > resultadoStock) {
          // si la cantidad ingresada es mayor al resultado de stock da verdadero, esto nos indica que no hay stock
          console.log(`El producto ${e.name} sobrepasa el stock`)
          // Swal.fire(
          //   `El producto ${e.name} sobrepasa el stock`
          //   );
            
            noStock.push(...noStock, {name:e.name, stock: resultadoStock})
          //return (stockPermitido = true);
        }
      } 
      // else {
      //   const stockItem = items.find((e) => e._id === product.item); //filtramos el articulo desde nuestro array de articulos
      //   console.log(stockItem);

      //   if (parseInt(product.quantity) > stockItem.stockTotal) {
      //     console.log(`El producto ${e.name} sobrepasa el stock`)
      //     Swal.fire(
      //       `Acaba de ingresar una cantidad que supera al stock actual. Stock permitido ${stockItem.stockTotal}`
      //     );
      //     return noStock.push(...noStock, {name:e.name, stock: stockItem.stockTotal})
      //   }

      //   console.log("bye");
      // }

       }


     }) //cierre del map
    
     if(noStock.length > 0) {
      let noStockSet = [...new Set(noStock)]
      let arrayStockSet = Array.from(noStockSet)
      console.log(arrayStockSet);
      Swal.fire({
      //   `${arrayStockSet.map(e =>       
      //   `Art: ${e.name} - Permitido ${e.stock}`        
      // )}`
            html: arrayStockSet.map(x => `Art: ${x.name} - Permitido ${x.stock}</br>`)
       }
      )
     }
     
     console.log(noStock);
  };

  
  const handleQuantity = (e) => {
    const { value } = e.target;
    console.log(value);

    setProduct({
      ...product,
      [e.target.name]: value,
    });
  };

  const quantityForm = (e) => {
    const { value } = e.target;
    console.log(e.target.name)
    const auxItem = form.quantityItems
  }

  const handleItem = (e) => {
    //console.log(e.label[2])
    const auxDescription = items.filter((x) => x._id === e.value);

    setProduct({
      ...product,
      item: e.value,
      name: e.label[2],
      descrip: auxDescription[0].description,
    });
  };

  const handleDeleteArt = (e) => {
    //console.log(e.target);
    setForm({
      ...form,
      quantityItems: form.quantityItems.filter(
        (x) => x.item !== e.target.value
      ),
    });
  };

  const bucleStock = () => {
    const inicio = new Date(form.dateSend);
    const fin = new Date(form.dateReception);
    // const inicio = new Date("2023-06-01T00:00:00");
    // const fin = new Date("2023-06-30T00:00:00");
    const UN_DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24;
    const INTERVALO = UN_DIA_EN_MILISEGUNDOS * 7; // Cada semana
    const formateadorFecha = new Intl.DateTimeFormat({ dateStyle: "medium" });
    let stockPermitido = false;
    //console.log(inicio)
    for (
      let i = inicio;
      i <= fin;
      i = new Date(i.getTime() + UN_DIA_EN_MILISEGUNDOS)
    ) {
      // Iteramos de fecha de ingreso a fecha de recepcion por dia
      //console.log(format(i, "yyyy/MM/dd"))
      //let stockPermitido = false;
      let day = i;
      

      const documentsFilter = documents[0].filter(
        (e) =>
          new Date(e.dateReception) >= day &&
          new Date(e.dateSend) <= day && e.state === false &&
          e._id !== id
      ); //filtramos los remitos que esten activos el dia que se esta iterando
      console.log(documentsFilter);
      

      const auxItem = documentsFilter.map((e) =>
        e.quantityItems.find((x) => x.item === product.item)
      ); // filtramos los articulos que ingresamos en el formulario
      console.log(auxItem);

      const auxItemFilter = auxItem.filter(e => e !== undefined)
      console.log(auxItemFilter)

      if (auxItemFilter !== undefined) {
        console.log("ok");
        let sumaStock = 0; // recorremos las diferentes cantidades del articulo y las sumamos
        auxItemFilter.forEach(function (x) {
          sumaStock = parseInt(x.quantity) + sumaStock;
        });
        console.log(sumaStock);

        const stockItem = items.filter((e) => e._id === product.item); //filtramos el articulo desde nuestro array de articulos
        console.log(stockItem);

        const resultadoStock = stockItem[0].stockTotal - sumaStock; // restamos la suma de cantidades al stock total, dandonos por resultado el stock libre por dia
        console.log(resultadoStock);
        console.log(product.quantity)

        if (product.quantity > resultadoStock) {
          // si la cantidad ingresada es mayor al resultado de stock da verdadero, esto nos indica que no hay stock

          Swal.fire(
            "Acaba de ingresar una cantidad que supera al stock actual"
          );
          return (stockPermitido = true);
        }
      } else {
        const stockItem = items.find((e) => e._id === product.item); //filtramos el articulo desde nuestro array de articulos
        //console.log(stockItem);

        if (product.quantity > stockItem.stockTotal) {
          Swal.fire(
            "Acaba de ingresar una cantidad que supera al stock actual"
          );
          return;
        }

        console.log("bye");
      }

      console.log(formateadorFecha.format(i));
    }
  };

  const handleSuma = (e) => {
    const { value } = e.target;
     console.log(value)
  if( e.keyCode === 13){

    if (product.item === "" || product.quantity === "") {
      Swal.fire("Debe seleccionar artículo y cantidad");
      return
    } 
    // else if (parseInt(product.quantity) === 0) {
    //   Swal.fire("Debe ingresar un valor mas alto a 0");
    //   return;
    // }

      const auxItem = form.quantityItems.find(e => e.item === product.item)
      
      if(auxItem) {
        Swal.fire("Articulo ingresado")
        return;
      }
      
    bucleStock();
    if(bucleStock() === true){
      console.log("es verdadero")
      return
    } else { 
      console.log("es falso")
      setForm({
        ...form,
        quantityItems: [...form.quantityItems, product],
      });
      setProduct({
        item: product.item,
        name: product.name,
        quantity: product.quantity,
        price: 0,
        totalPrice:0
      });
    }

  }
  };

  const handleQuantityMod = (e, item, name, descrip, quantity) => {
    const { value } = e.target;
    console.log(value, item, name, descrip);

    setProduct({
      ...product,
      item: item,
      name: name,
      descrip: descrip,
      [e.target.name]: value,
    });
  };

  const handleSumaMod = (e, item, name, descrip, quantity) => {
    const { value } = e.target;
     console.log(value, item, name, descrip, quantity)
  if( e.keyCode === 13){

    //setProduct({...product, item: item, name: name, descrip: descrip, quantity: value})

    
    
      if (product.item === "" || product.quantity === "") {
        Swal.fire("Debe seleccionar artículo y cantidad");
        return
      } 
      else if (parseInt(product.quantity) === 0) {
        Swal.fire("Debe ingresar un valor mas alto a 0");
        return;
      }      
      
    
    // const auxItem = form.quantityItems.find(e => e.item === product.item)
    
    // if(auxItem) {
      //   Swal.fire("Articulo ingresado")
      //   return;
      // }
      
      console.log(product);
    bucleStockMod();
    if(bucleStockMod() === true){
      console.log("es verdadero")
      return
    } else { 
      console.log("es falso")
      setForm({
  ...form,
  quantityItems: form.quantityItems.map((x) =>
    x.item === product.item
      ? {
          ...x,
          quantity: product.quantity,
        }
      : x
  ),
});
      setProduct({
        item: product.item,
        name: product.name,        
        quantity: "",
        price: 0,
        totalPrice:0
      });
    }
  }
  };

  const bucleStockMod = () => {
    const inicio = new Date(form.dateSend);
    const fin = new Date(form.dateReception);
    // const inicio = new Date("2023-06-01T00:00:00");
    // const fin = new Date("2023-06-30T00:00:00");
    const UN_DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24;
    const INTERVALO = UN_DIA_EN_MILISEGUNDOS * 7; // Cada semana
    const formateadorFecha = new Intl.DateTimeFormat({ dateStyle: "medium" });
    let stockPermitido = false;
    //console.log(inicio)
    for (
      let i = inicio;
      i <= fin;
      i = new Date(i.getTime() + UN_DIA_EN_MILISEGUNDOS)
    ) {
      // Iteramos de fecha de ingreso a fecha de recepcion por dia
      //console.log(format(i, "yyyy/MM/dd"))
      //let stockPermitido = false;
      let day = i;
      

      const documentsFilter = documents[0].filter(
        (e) =>
          new Date(e.dateReception) >= day &&
          new Date(e.dateSend) <= day && e.state === false &&
          e._id !== id
      ); //filtramos los remitos que esten activos el dia que se esta iterando
      console.log(documentsFilter);
      

      const auxItem = documentsFilter.map((e) =>
        e.quantityItems.find((x) => x.item === product.item)
      ); // filtramos los articulos que ingresamos en el formulario
      console.log(auxItem);

      const auxItemFilter = auxItem.filter(e => e !== undefined)
      console.log(auxItemFilter)

      if (auxItemFilter !== undefined) {
        console.log("ok");
        let sumaStock = 0; // recorremos las diferentes cantidades del articulo y las sumamos
        auxItemFilter.forEach(function (x) {
          sumaStock = parseInt(x.quantity) + sumaStock;
        });
        console.log(sumaStock);

        const stockItem = items.filter((e) => e._id === product.item); //filtramos el articulo desde nuestro array de articulos
        console.log(stockItem);

        const resultadoStock = stockItem[0].stockTotal - sumaStock; // restamos la suma de cantidades al stock total, dandonos por resultado el stock libre por dia
        console.log(resultadoStock);
        console.log(product.quantity)

        if (product.quantity > resultadoStock) {
          // si la cantidad ingresada es mayor al resultado de stock da verdadero, esto nos indica que no hay stock

          Swal.fire(
            "Acaba de ingresar una cantidad que supera al stock actual"
          );
          return (stockPermitido = true);
        }
      } else {
        const stockItem = items.find((e) => e._id === product.item); //filtramos el articulo desde nuestro array de articulos
        //console.log(stockItem);

        if (product.quantity > stockItem.stockTotal) {
          Swal.fire(
            "Acaba de ingresar una cantidad que supera al stock actual"
          );
          return;
        }

        console.log("bye");
      }

      console.log(formateadorFecha.format(i));
    }
  };

  const opendPDF = () => {
    setVerPDF(true)
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(form);

    if (
      !form.quantityItems.length ||
      form.addressEvent === "" ||
      form.dateSend === "" ||
      form.dateReception === ""
    ) {
      return Swal.fire("Hay campos sin completar");
    } else {
      dispatch(putDocuments(id, form));
      setForm({
        quantityItems: [],
        addressEvent: "",
        dateSend: "",
        dateReception: "",
      });
      setTimeout(() => {
        navigate(`/documentos/${documentId._id}`)
        
      }, 300);
    }
  };

  return (
    <div className="min-w-full bg-gray-900">
      <div className="container m-4 text-orange-500 text-[10pt] font-bold">
      <div>
      <div>
                <p className="text-xl pb-8 underline">Remito a Modificar</p>
            </div>
        <div className="flex w-3/3 border-b-2 border-slate-500 pb-2">
          <p className="w-1/3">Documento N°: {documentId.numberDocument}</p>
          <p className="w-1/3">Fecha: {documentId.createdAt ? format(new Date(documentId.createdAt), "dd/MM/yyyy") : null}</p>
          <p className="w-1/3">Estado: {documentId.state === false ? "No Saldado" : "Saldado"}</p>
        </div>        
          {documentId.client_id === undefined ? (
            <div className="w-full py-2 border-b-2 border-slate-500">
            <div className="flex">
              <p className="w-1/4">Cliente N°:</p>
              <p className="w-1/4">Compañia:</p>
              <p className="w-1/4">Nombre:</p>
              <p className="w-1/4">Apellido:</p>
            </div>
            <div className="flex">
              <p className="w-1/4">Dirección:</p>
              <p className="w-1/4">Ciudad:</p>
              <p className="w-1/4">Telefonos:</p>
              <p className="w-1/4">E-mail:</p>
            </div>            
            </div>
          ) : (
            <div className="w-full py-2 border-b-2 border-slate-500">
              <div className="flex ">
                <p className="w-1/4">Cliente N°: {documentId.client_id.idClient}</p>
                <p className="w-1/4">Compañia: {documentId.client_id.nameCompany}</p>
                <p className="w-1/4">Nombre: {documentId.client_id.name}</p>
                <p className="w-1/4">Apellido: {documentId.client_id.lastName}</p>
              </div>
              <div className="flex">
                <p className="w-1/4">Dirección: {documentId.client_id.address}</p>
                <p className="w-1/4">Ciudad: {documentId.client_id.city}</p>
                <p className="w-1/4">Telefonos: {documentId.client_id.telephoneNumber}</p>
                <p className="w-1/4">E-mail: {documentId.client_id.email}</p>
              </div>              
            </div>
          )}        
        <div className="border-b-2 border-slate-500 py-2">
          <label className="text-[12pt] ml-4 pr-2">Modificar</label>
          <input type="checkbox" checked={check} onChange={checkBox} />
        </div>
        {check === false ? (
          <div>
            <div className="w-3/3 flex border-b-2 border-slate-500 py-2">
              <p className="w-1/3">Dirección de evento: {documentId.addressEvent}</p>
              <p className="w-1/3">Fecha de envío: {documentId.dateSend ? format(new Date(documentId.dateSend), "dd/MM/yyyy") : null}</p>
              <p className="w-1/3">Fecha de recepción: {documentId.dateReception ? format(new Date(documentId.dateReception), "dd/MM/yyyy") : null}</p>
            </div>
            <div className="pt-4">
                    <p className="font-bold text-[12pt]">Artículos:</p>
            </div>
            <div className="flex w-full border-b-2 border-slate-500 py-1">
              <p className="w-1/3">Nombre</p>
              <p className="w-2/5">Descripcion</p>
              <p className="w-20 text-center">Cantidad</p>
            </div>
            {documentId.quantityItems === undefined ? (
              <div></div>
            ) : (
              <div>
                {documentId.quantityItems.map((e, index) => {
                  return (
                    <div
                      key={index}
                      className="flex border-b-2 border-slate-500 text-[9pt] py-1"
                    >
                      <div className="w-1/3">{e.name}</div>
                      <div className="w-2/5">{e.descrip}</div>
                      <div className="w-20 text-center">{e.quantity}</div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ) : (
          <div>
            <div className="w-3/3 flex border-b-2 border-slate-500 py-2">
              <p className="w-1/3">Dirección de evento: {documentId.addressEvent}</p>
              <p className="w-1/3">Fecha de envío: {documentId.dateSend ? format(new Date(documentId.dateSend), "dd/MM/yyyy") : null}</p>
              <p className="w-1/3">Fecha de recepción: {documentId.dateReception ? format(new Date(documentId.dateReception), "dd/MM/yyyy") : null}</p>
            </div>
            <div className="flex border-b-2 border-slate-500 py-2">
              <div className="w-1/3">
                <label className="w-1/3 pr-2">Dirección de evento:</label>
                <input
                  className="bg-slate-700 rounded w-1/2 pl-2"
                  type="text"
                  name="addressEvent"
                  placeholder=""
                  onChange={handleAddress}
                  value={form.addressEvent}
                />
              </div>
              <div className="flex w-1/3">
                <label className="w-32">Fecha de envío</label>
                <DatePicker
                  className="w-32 pl-6 rounded bg-slate-700"
                  selected={new Date(documentId.dateSend)}
                  onChange={handleDateSend}
                  value={form.dateSend ? format(new Date(form.dateSend), "dd/MM/yyyy") : null}
                />
              </div>
              <div className="flex w-1/3">
                <label className="w-44">Fecha de recepción</label>
                <DatePicker
                  className="w-32 pl-6 rounded bg-slate-700"
                  selected={new Date(documentId.dateReception)}
                  onChange={handleDateReception}
                  value={form.dateReception ? format(new Date(form.dateReception), "dd/MM/yyyy") : null}
                />
              </div>
            </div>
            <div className="pt-4">
                    <p className="font-bold text-[12pt]">Artículos:</p>
            </div>
            <div className="flex w-full border-b-2 border-slate-500 py-1">
              <div className="w-1/3">Articulo</div>
              <div className="w-2/5">Descripcion</div>
              <div className="w-20 text-center">Cantidad</div>
              <div className="w-14 text-center">Eliminar</div>
            </div>            
            <div>
              {form.quantityItems.map((e, index) => {
                return (
                  <div
                    key={index}
                    className="flex border-b-2 border-slate-500 text-[9pt] py-1"
                  >
                    <div className="w-1/3">{e.name}</div>
                    <div className="w-2/5">{e.descrip}</div>
                    {/* <div className="w-20 text-center">{e.quantity}</div> */}
                    <input 
                      className="w-20 text-center placeholder-orange-500 bg-slate-700"
                      name="quantity"
                      placeholder={e.quantity} 
                      onChange={(x)=> handleQuantityMod(x, e.item, e.name, e.descrip, e.quantity)}
                      onKeyUp={handleSumaMod}
                      //value={e.quantity} 
                    />
                    <div className="w-14 text-center">                
                    <button value={e.item} onClick={handleDeleteArt} className="w-8 text-[8pt] border-2 border-black bg-red-500 hover:bg-red-600 text-white font-bold">
                      X
                    </button>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="flex w-full pt-2">
            <label className="w-1/3 text-[10pt] pl-20">Seleccionar Articulos</label>
            <label className="w-36 text-[10pt] pl-10">Cantidad</label>
            </div>
            <div className="flex">
              <div className="w-1/3">
                <Select
                  options={items.map((e) => ({
                    label: [e.idItem, "- ", e.name, " - ", e.description],
                    value: e._id,
                  }))}
                  styles={customStylesItems}
                  onChange={handleItem}
                />
              </div>
              <div className="w-36 h-5 pl-5">
                <input
                    className="border rounded w-24 h-5 pt-2"
                    type="text"
                    name="quantity"
                    onChange={handleQuantity}
                    onKeyUp={handleSuma}
                    value={product.quantity}
                  />
              </div>
              </div>              
          </div>
        )}
      </div>
      <div className="flex flex-row justify-around">
        <button
          className="mt-12 p-4 rounded bg-sky-500 text-white"
          onClick={handleSubmit}
        >
          Guardar
        </button>   
        <button className="mt-12 p-4 rounded bg-sky-500 text-white" onClick={opendPDF}>Ver PDF</button>     
      </div>
      <div>
          {verPDF ? (
            <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-0-sm
              flex flex-col justify-center items-center">
              <div className="bg-red-500 w-1/12 text-center rounded hover:bg-red-600">
                <button className="text-black font-bold hover:text-white" onClick={()=> setVerPDF(false)}>Cerrar</button>
              </div>
             {/* <NewWindow> */}
              <div>
                <DetailPDF
                  key={id} 
                  id={id}
                  document={documentId}
                />
              </div>
              {/* </NewWindow> */}
            </div>
          ) : null}
        </div>
        </div>
    </div>
  );
}